/**
 * Widgets Component
 *
 * @component
 * @description This component serves as a container for displaying document references, notes, and spreadsheet notes widgets based on the specified page origin.
 *
 * @param {string} pageOrigin - The origin or type of the current page.
 * @param {Object} documentReferencesProps - Properties for the DocumentReferences component.
 * @param {Object} notesProps - Properties for the Notes component.
 * @param {Object} spreadsheetNotesProps - Properties for the SpreadsheetNotes component.
 * @returns {JSX.Element|null} - A JSX element representing the Widgets component or null if no content should be displayed.
 */
import React from 'react';
import { isEmpty } from 'lodash';
import DocumentReferences from 'components/Documents/components/documents/DocumentReferences';
import { Notes } from 'components/Notes';
import { SpreadsheetNotes } from 'components/SpreadsheetNotes';
import { IWidget } from './types';

const Widgets = ({
  documentReferencesProps,
  notesProps,
  spreadsheetNotesProps,
  onDocumentClick,
  documentSourceProps,
}: IWidget) => {
  // If documentReferencesProps, notesProps, and spreadsheetNotesProps don't exist or are empty
  if (
    isEmpty(documentReferencesProps) &&
    !notesProps &&
    isEmpty(notesProps) &&
    !spreadsheetNotesProps &&
    isEmpty(spreadsheetNotesProps)
  ) {
    return null;
  }
  return (
    <div>
      {documentReferencesProps && (
        <DocumentReferences
          {...documentReferencesProps}
          documentSourceProps={documentSourceProps}
          onClick={onDocumentClick}
        />
      )}
      {notesProps && <Notes {...notesProps} />}
      {spreadsheetNotesProps && <SpreadsheetNotes {...spreadsheetNotesProps} />}
    </div>
  );
};

export default Widgets;
